import { createContext } from 'react';

const CasesContext = createContext(null);

export default CasesContext;
